/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Tooltip } from '@neo4j-ndl/react';

const triggerStyle: React.CSSProperties = {
  alignItems: 'center',
  backgroundColor: 'var(--theme-color-primary-bg-weak)',
  borderRadius: '4px',
  color: 'var(--theme-color-primary-text-inverse)',
  display: 'flex',
  height: '300px',
  justifyContent: 'center',
  padding: '8px',
  width: '300px',
};

const Component = () => {
  return (
    <div style={{ display: 'flex', gap: '24px' }}>
      <Tooltip
        type="simple"
        followCursor
        placement="bottom"
        hoverDelay={{ close: 0, open: 500 }}
      >
        <Tooltip.Trigger>
          <div style={triggerStyle}>
            followCursor with placement=&quot;bottom&quot;: follows on the
            x-axis
          </div>
        </Tooltip.Trigger>
        <Tooltip.Content>Follows cursor along the x-axis</Tooltip.Content>
      </Tooltip>

      <Tooltip
        type="simple"
        followCursor
        placement="right"
        hoverDelay={{ close: 0, open: 500 }}
      >
        <Tooltip.Trigger>
          <div style={triggerStyle}>
            followCursor with placement=&quot;right&quot;: follows on the y-axis
          </div>
        </Tooltip.Trigger>
        <Tooltip.Content>Follows cursor along the y-axis</Tooltip.Content>
      </Tooltip>

      <Tooltip
        type="simple"
        followCursor="initial"
        placement="bottom"
        hoverDelay={{ close: 0, open: 500 }}
      >
        <Tooltip.Trigger>
          <div style={triggerStyle}>
            followCursor=&quot;initial&quot;: opens at the cursor point and
            stays there
          </div>
        </Tooltip.Trigger>
        <Tooltip.Content>
          Pinned at the cursor position it opened at
        </Tooltip.Content>
      </Tooltip>
    </div>
  );
};

export default Component;
